// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

const OAuthRedirectUrl = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/dashboard';
export const environment = {
    kibanaDashboardGraph1: "KIBANA_DASHBOARD_GRAPH1_PLACEHOLDER&_g=(refreshInterval%3A(display%3AOff%2Cpause%3A!f%2Cvalue%3A0)%2Ctime%3A(from%3Anow-30d%2Cmode%3Aquick%2Cto%3Anow))",
    kibanaDashboardGraph2: "KIBANA_DASHBOARD_GRAPH2_PLACEHOLDER&_g=(refreshInterval%3A(display%3AOff%2Cpause%3A!f%2Cvalue%3A0)%2Ctime%3A(from%3Anow-30d%2Cmode%3Aquick%2Cto%3Anow))",
    kibanaDashboardGraph3: "KIBANA_DASHBOARD_GRAPH3_PLACEHOLDER&_g=(refreshInterval%3A(display%3AOff%2Cpause%3A!f%2Cvalue%3A0)%2Ctime%3A(from%3Anow-30d%2Cmode%3Aquick%2Cto%3Anow))",
    kibanaTimes1: "KIBANA_TIMES1_PLACEHOLDER&_g=(refreshInterval%3A(display%3AOff%2Cpause%3A!f%2Cvalue%3A0)%2Ctime%3A(from%3Anow-5y%2Cmode%3Aquick%2Cto%3Anow))",
    kibanaReasonOfRejections1: "KIBANA_REASON_OF_REJECTIONS1_PLACEHOLDER&_g=(filters%3A!()%2CrefreshInterval%3A(display%3AOff%2Cpause%3A!f%2Cvalue%3A0)%2Ctime%3A(from%3A'{{from}}T22%3A00%3A00.000Z'%2Cmode%3Aabsolute%2Cto%3A'{{to}}T12%3A10%3A04.944Z'))",
    kibanaReasonOfRejections2: "KIBANA_REASON_OF_REJECTIONS2_PLACEHOLDER&_g=(filters%3A!()%2CrefreshInterval%3A(display%3AOff%2Cpause%3A!f%2Cvalue%3A0)%2Ctime%3A(from%3A'{{from}}T22%3A00%3A00.000Z'%2Cmode%3Aabsolute%2Cto%3A'{{to}}T12%3A10%3A04.944Z'))",
    production: true,
	authUrl: "AUTH_URL_PLACEHOLDER",
	restUrl: "https://" + window.location.hostname + "/partc/v1.0/",
    elasticUrl: "ELASTIC_URL_PLACEHOLDER",
    OAuthRedirectUrl,
    OAuthClientId: "OAUTH_CLIENT_ID_PLACEHOLDER",
    OAuthSecret: "OAUTH_SECRET_PLACEHOLDER",
    partAUrl: "PARTA_URL_PLACEHOLDER",
    elasticName: "ELASTIC_NAME_PLACEHOLDER",
    elasticSecret: "ELASTIC_SECRET_PLACEHOLDER",
    translate: {
        languages: ["en", "es", "fr"],
        defaultLanguage: "DEFAULT_LANGUAGE_PLACEHOLDER"
	},
	systemCode: "SYSTEM_CODE_PLACEHOLDER"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts